import { isStepTestPath } from "../../shared/stepConfig";

// A React-key signature of the files a step serves at the current head commit — head_commit_id is stable across an LLM turn (files mutate in place on the working commit), so we key on the file blobs, not the commit id.
type FileRow = { path: string; blobHash: string };

export function stepContentKey(
  stepDir: string,
  files: readonly FileRow[] | undefined
): string {
  if (!files) return "";
  const prefix = `${stepDir}/`;
  return files
    .filter((f) => f.path.startsWith(prefix) && !isStepTestPath(f.path))
    .map((f) => f.blobHash)
    .sort()
    .join(":");
}
